export type SwStatus = "idle" | "checking" | "active" | "waiting" | "error";

interface PwaUpdateGlobal {
  state: SwStatus;
  needsUpdate: boolean;
  update: (() => void) | null;
  version: string;
}

declare global {
  interface Window {
    __zappyPwa?: PwaUpdateGlobal;
  }
}

export function initPwaState(version: string) {
  window.__zappyPwa = {
    state: "idle",
    needsUpdate: false,
    update: null,
    version,
  };
}

export function setPwaState(partial: Partial<PwaUpdateGlobal>) {
  if (!window.__zappyPwa) return;
  window.__zappyPwa = { ...window.__zappyPwa, ...partial };
  window.dispatchEvent(new CustomEvent("zappy-pwa-state-change"));
}

export function getPwaState(): PwaUpdateGlobal | undefined {
  return window.__zappyPwa;
}
